import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-72e2ccde"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "fr-menu" };
const _hoisted_2 = { class: "fr-menu__toolbar" };
const _hoisted_3 = { class: "fr-menu__grid" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["src", "alt"];
const _hoisted_6 = ["src"];
import { computed, onMounted, onUnmounted, ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'MenuGalleryApp',
    props: {
        pageCount: {},
        locale: {},
        imageBase: {}
    },
    setup(__props) {
        /**
         * 超狂菜單（移植自 prototype/menu.html）。
         *
         * 菜單是整張圖，中英各一套；點圖開燈箱，可左右翻頁、Esc 關閉。
         * 圖片路徑由 blade 以 $asset->path() 算好傳進來，理由同訂位頁的 bannerImage：
         * 本站掛在子目錄，寫死路徑換掛載點就破圖。
         */
        const props = __props;
        /** 目前看的是哪一套圖。預設跟著網站語系走，頁內也能自己切。 */
        const isEn = ref(String(props.locale || '').toLowerCase().startsWith('en'));
        const lightboxIndex = ref(0);
        const lightboxOpen = computed(() => lightboxIndex.value > 0);
        const pages = computed(() => Array.from({ length: props.pageCount }, (_, i) => i + 1));
        function imageUrl(n) {
            return `${props.imageBase}/menu${n}${isEn.value ? '_en' : ''}.jpg`;
        }
        function openLightbox(n) {
            lightboxIndex.value = n;
        }
        function closeLightbox() {
            lightboxIndex.value = 0;
        }
        /** 左右翻頁，頭尾相接。 */
        function step(delta) {
            const total = props.pageCount;
            lightboxIndex.value = ((lightboxIndex.value - 1 + delta + total) % total) + 1;
        }
        function onKeydown(e) {
            if (!lightboxOpen.value) {
                return;
            }
            if (e.key === 'Escape') {
                closeLightbox();
            }
            else if (e.key === 'ArrowLeft') {
                step(-1);
            }
            else if (e.key === 'ArrowRight') {
                step(1);
            }
        }
        onMounted(() => document.addEventListener('keydown', onKeydown));
        onUnmounted(() => document.removeEventListener('keydown', onKeydown));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass({ on: !isEn.value }),
                        onClick: _cache[0] || (_cache[0] = ($event) => (isEn.value = false))
                    }, "中文", 2),
                    _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass({ on: isEn.value }),
                        onClick: _cache[1] || (_cache[1] = ($event) => (isEn.value = true))
                    }, "English", 2)
                ]),
                _createElementVNode("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pages.value, (n) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: n,
                            class: "fr-menu__card",
                            onClick: ($event) => (openLightbox(n))
                        }, [
                            _createElementVNode("img", {
                                src: imageUrl(n),
                                alt: `菜單第 ${n} 頁`,
                                loading: "lazy"
                            }, null, 8, _hoisted_5)
                        ], 8, _hoisted_4));
                    }), 128))
                ]),
                (lightboxOpen.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "fr-lightbox",
                        onClick: _withModifiers(closeLightbox, ["self"])
                    }, [
                        _createElementVNode("span", {
                            class: "fr-lightbox__close",
                            onClick: closeLightbox
                        }, "×"),
                        _createElementVNode("span", {
                            class: "fr-lightbox__nav fr-lightbox__nav--prev",
                            onClick: _cache[2] || (_cache[2] = ($event) => (step(-1)))
                        }, "‹"),
                        _createElementVNode("img", {
                            src: imageUrl(lightboxIndex.value),
                            alt: "菜單"
                        }, null, 8, _hoisted_6),
                        _createElementVNode("span", {
                            class: "fr-lightbox__nav fr-lightbox__nav--next",
                            onClick: _cache[3] || (_cache[3] = ($event) => (step(1)))
                        }, "›")
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
